import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var departmentListRes;
export const departmentListTodo = createAsyncThunk('departmentList', async () => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/department_list',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return departmentListRes = res.data
    } catch (error) {
        return departmentListRes = error.response.data
    }
})


const departmentListSlice = createSlice({
    name: 'departmentList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(departmentListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('departmentList', state.data)
            }
        });
        builder.addCase(departmentListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default departmentListSlice.reducer; 